import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  TextField,
  Typography,
  Container,
  CssBaseline,
  Card,
  styled,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { SEND_EMAIL_MUTATION } from "../../graphql/mutations";

const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $email: String!
    $password: String!
    $resetToken: String!
  ) {
    resetPassword(email: $email, password: $password, resetToken: $resetToken) {
      email
    }
  }
`;

const REQUEST_RESET = gql`
  mutation RequestReset($email: String!) {
    requestReset(email: $email) {
      email
      resetToken
    }
  }
`;

const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [stage, setStage] = useState("requestReset");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [requestResett] = useMutation(REQUEST_RESET);
  const [resetPasswordMutation] = useMutation(RESET_PASSWORD);
  const [sendEmail] = useMutation(SEND_EMAIL_MUTATION);
  const requestReset = async () => {
    const randomCode = Math.floor(100000 + Math.random() * 900000).toString();
    setVerificationCode(randomCode); // Generate a random 6 digit code
    sendEmail({
      variables: {
        to: email,
        subject: "Your verification code",
        text: `Your verification code is ${randomCode}`,
      },
    })
      .then(async (val) => {
        try {
          const result = await requestResett({
            variables: { email },
          });
          setResetToken(result.data.requestReset.resetToken);
        } catch (error) {
          console.error("Failed to request reset", error);
        }
      })
      .catch((val) => {
        console.error("Error is:" + val);
      });
    // Request reset token
    setStage("enterCode");
  };

  const verifyResetCode = () => {
    if (code === verificationCode) {
      setStage("resetPassword");
    } else {
      console.error("Incorrect code");
    }
  };

  const resetUserPassword = async () => {
    if (password !== confirmPassword) {
      console.error("Passwords don't match");
      return;
    }
    // Call the reset password mutation
    try {
      await resetPasswordMutation({
        variables: {
          email,
          password,
          resetToken,
        },
      });
      setStage("success");
    } catch (error) {
      console.error("Failed to reset password", error);
    }
  };

  switch (stage) {
    case "requestReset":
      return (
        <Container component="main" maxWidth="xs">
          <Card>
            {" "}
            <CssBaseline />
            <div
              className="flex align column"
              style={{ margin: "20px 0 ", gap: "20px" }}
            >
              <Avatar>
                <LockOutlined />
              </Avatar>
              <Typography component="h1" variant="h5">
                Password Reset Request
              </Typography>
              <div style={{ margin: "0 10px", width: "90%" }}>
                <TextField
                  label="Email Address"
                  value={email}
                  style={{ width: "100%" }}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <Typography
                className="font"
                style={{
                  textAlign: "center",
                  maxWidth: "350px",
                  fontSize: "14px",
                }}
              >
                Enter your account's email below. If it's linked to an account,
                we'll send a verification code to proceed with password reset.
              </Typography>
              <Button onClick={requestReset}>Send Me A Reset Link</Button>
            </div>
          </Card>
        </Container>
      );

    case "enterCode":
      return (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Card>
            <div
              className="flex align column"
              style={{ margin: "20px 0 ", gap: "20px" }}
            >
              <Avatar>
                <LockOutlined />
              </Avatar>
              <Typography component="h1" variant="h5">
                Verify Code
              </Typography>
              <TextField
                label="Verification Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                inputProps={{ maxLength: 6 }}
              />
              <Button onClick={verifyResetCode}>Verify Code</Button>
            </div>
          </Card>
        </Container>
      );

    case "resetPassword":
      return (
        <Container component="main" maxWidth="xs">
          <Card>
            <CssBaseline />
            <div
              className="flex align column"
              style={{ margin: "20px 0 ", gap: "20px" }}
            >
              <Avatar>
                <LockOutlined />
              </Avatar>
              <Typography component="h1" variant="h5">
                Reset Password
              </Typography>
              <TextField
                label="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                label="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <Button onClick={resetUserPassword}>Reset Password</Button>
            </div>
          </Card>
        </Container>
      );

    case "success":
      return (
        <Container component="main" maxWidth="xs">
          <Card>
            <CssBaseline />
            <div
              className="flex align column"
              style={{ margin: "20px 0 ", gap: "20px" }}
            >
              <Typography>Password Successfully Changed.</Typography>
              <Button onClick={() => navigate("/app/events")}>
                Go To Home
              </Button>
            </div>
          </Card>
        </Container>
      );

    default:
      return null;
  }
};

export default ForgotPassword;
